/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Tabs_ItemInputs */

const id_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const ms_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const da_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const de_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const en_us2_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const es_es2_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítem`)
};

const es_mx2_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítem`)
};

const fil_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const fr_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const it_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articolo`)
};

const hu_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elem`)
};

const nl_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const no_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element`)
};

const pl_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element`)
};

const pt_br2_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const pt_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const ro_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element`)
};

const fi_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohde`)
};

const sv_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objekt`)
};

const vi_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục`)
};

const tr_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğe`)
};

const cs_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položka`)
};

const bg_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обект`)
};

const ru_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объект`)
};

const uk_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Елемент`)
};

const ar_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عنصر`)
};

const hi_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइटम`)
};

const th_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการ`)
};

const ja_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテム`)
};

const zh_cn2_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品`)
};

const zh_hant1_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品`)
};

const ko_items_tabs_item = /** @type {(inputs: Items_Tabs_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이템`)
};

/**
* | output |
* | --- |
* | "Item" |
*
* @param {Items_Tabs_ItemInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_tabs_item = /** @type {((inputs?: Items_Tabs_ItemInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Tabs_ItemInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_tabs_item(inputs)
	if (locale === "ms") return ms_items_tabs_item(inputs)
	if (locale === "da") return da_items_tabs_item(inputs)
	if (locale === "de") return de_items_tabs_item(inputs)
	if (locale === "en-US") return en_us2_items_tabs_item(inputs)
	if (locale === "es-ES") return es_es2_items_tabs_item(inputs)
	if (locale === "es-MX") return es_mx2_items_tabs_item(inputs)
	if (locale === "fil") return fil_items_tabs_item(inputs)
	if (locale === "fr") return fr_items_tabs_item(inputs)
	if (locale === "it") return it_items_tabs_item(inputs)
	if (locale === "hu") return hu_items_tabs_item(inputs)
	if (locale === "nl") return nl_items_tabs_item(inputs)
	if (locale === "no") return no_items_tabs_item(inputs)
	if (locale === "pl") return pl_items_tabs_item(inputs)
	if (locale === "pt-BR") return pt_br2_items_tabs_item(inputs)
	if (locale === "pt") return pt_items_tabs_item(inputs)
	if (locale === "ro") return ro_items_tabs_item(inputs)
	if (locale === "fi") return fi_items_tabs_item(inputs)
	if (locale === "sv") return sv_items_tabs_item(inputs)
	if (locale === "vi") return vi_items_tabs_item(inputs)
	if (locale === "tr") return tr_items_tabs_item(inputs)
	if (locale === "cs") return cs_items_tabs_item(inputs)
	if (locale === "bg") return bg_items_tabs_item(inputs)
	if (locale === "ru") return ru_items_tabs_item(inputs)
	if (locale === "uk") return uk_items_tabs_item(inputs)
	if (locale === "ar") return ar_items_tabs_item(inputs)
	if (locale === "hi") return hi_items_tabs_item(inputs)
	if (locale === "th") return th_items_tabs_item(inputs)
	if (locale === "ja") return ja_items_tabs_item(inputs)
	if (locale === "zh-CN") return zh_cn2_items_tabs_item(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_tabs_item(inputs)
	return ko_items_tabs_item(inputs)
});
export { items_tabs_item as "items.tabs.item" }